<template>
<div id="contents">
     <!-- 头部组件 -->
     <component :is="header_"></component>
     <!--  -->
    <el-container class="el-container-vh" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <component :is="celan"></component>
      
      <el-container>
        <el-main>
          <el-table :data="tableData">
            <el-table-column align="center" width="111" prop="id" label="序号">
            </el-table-column>
            <el-table-column align="center" width="111" prop="paytype" label="类型">
            </el-table-column>
            <el-table-column align="center" width="111" prop="device" label="设备号">
            </el-table-column>
            <el-table-column align="center" prop="paymoney" label="金额">
            </el-table-column>
            <el-table-column prop="dingdan" label="订单号">
            </el-table-column>
            <el-table-column prop="ordername" label="商品名称">
            </el-table-column>
            <el-table-column label="订单状态">
               <template slot-scope="state">
                <i v-if="state.row.state==1" style="color:#85ce61">支付成功</i>
                <i v-if="state.row.state==-1" style="color:#ff0000">支付失败</i>
                <i v-if="state.row.state==0" style="color:#e6a23c">待支付中</i>
            </template>
            </el-table-column>
            <el-table-column width="150" label="操作">
              <template slot-scope="scope">
                  <el-button type="danger" style="padding:7px 5px;" @click="del(scope.row.id)">
                    删除
                  </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="8" 
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>

          </el-main>
      </el-container>
    </el-container>
</div>
</template>

<script>
//头部组件
import header_ from './header_.vue'
import celan from './celan.vue'
export default {
  name: 'header_',
   data() {
      return {
        tableData: null,
        total:null,
        header_:header_,
        celan:celan,
        imglist:'./login.php',
      }
    },
    methods: {
      //删除
      del(del_id){
          this.$http.post(this.imglist,{del_successpay:del_id},{emulateJSON:true}).then(res=>{
            this.tableData=res.body;
          });
      },
      //点击回调
      hd(hd_id){
          this.$http.post(this.imglist,{hd_successpay:hd_id},{emulateJSON:true}).then(res=>{
            this.tableData=res.body;
          });
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {

      }


    },
    created(){
      this.$http.post(this.imglist,{successpay:true},{emulateJSON:true}).then(res=>{
          this.tableData=res.body;
      });
       
    }
}
</script>


<style scoped>
.el-container-vh{
  height: 100vh;
}
@media screen and (max-width: 800px) {
  .el-container-vh{
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/successpay.vue